import { Timer } from "lucide-react";
import { useEffect, useState } from "react";

/**
 * Floating chip showing live mm:ss elapsed since the user entered fullscreen.
 * Visibility is fully controlled by the parent — pass startedAt=null to hide.
 */
export default function FocusSessionChip({ startedAt }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startedAt) {
      setElapsed(0);
      return;
    }
    const tick = () => setElapsed(Math.floor((Date.now() - startedAt) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [startedAt]);

  if (!startedAt) return null;

  const mm = Math.floor(elapsed / 60).toString().padStart(2, "0");
  const ss = (elapsed % 60).toString().padStart(2, "0");

  return (
    <div
      data-testid="focus-session-chip"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 px-4 py-2 rounded-full bg-islamic-blue-900/90 backdrop-blur border border-gold-400/30 shadow-lg pointer-events-none"
    >
      <Timer className="w-4 h-4 text-gold-400" />
      <span className="font-outfit text-sm tabular-nums text-slate-100">
        {mm}:{ss}
      </span>
      <span className="text-xs font-outfit text-slate-500 hidden sm:inline">
        focus
      </span>
    </div>
  );
}
